import { CmsFilters } from 'js/model/cms/cms-browse-page';
import { SearchOptions } from 'js/model/rainbow/browse-page/SearchOptions';
import { VenueListingSpecificationOutput } from 'js/model/rainbow/browse-page/VenueListingSpecificationOutput';
import i18next from 'i18next';
import { RadioOption } from '../FilterModal/RadioGroupFilter';

export const isSortFilterActive = ({
  sort,
}: VenueListingSpecificationOutput): boolean => sort !== 'recommended';

export const buildSortOptions = <
  T extends SearchOptions['sortOptions'][number],
>(
  searchOptions: SearchOptions,
  cmsFilters: CmsFilters
): RadioOption<T>[] => {
  const radioOptions: RadioOption<T>[] = [];
  const cmsSortOptions = cmsFilters['sort-options'];

  for (const sortOption of searchOptions.sortOptions) {
    const option = sortOption?.replace(
      '_',
      '-'
    ) as keyof CmsFilters['sort-options'];
    const label = cmsSortOptions[option];

    if (!label) {
      continue;
    }

    const radioOption: RadioOption<T> = {
      label,
      value: sortOption as T,
    };

    if (option === 'recommended') {
      radioOption.description = i18next.t('browsePage.filter.defaultSort');
    }

    radioOptions.push(radioOption);
  }

  return radioOptions;
};
